<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPickingForDeliverys"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-picking-number" label-cols-sm="4" label-cols-lg="3" label="Picking No" label-for="filter-picking-number" size="sm" :model.sync="filter.pickingNumber" />
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Instruction" id="filter-" size="sm" :model.sync="filter.deliveryInstructionId" @input="getDeliveryInstructions" @focus="getDeliveryInstructions" />
					<app-input-datepicker-range  id="fieldset-picking-date" label-cols-sm="4" label-cols-lg="3" label="Picking Date" size="sm" :modelFrom.sync="filter.pickingDateFrom" :modelTo.sync="filter.pickingDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-datetimepicker-range id="fieldset-finish-date" label-cols-sm="4" label-cols-lg="3" label="Finish Date" size="sm" :modelFrom.sync="filter.finishDateFrom" :modelTo.sync="filter.finishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Picking By" id="filter-" size="sm" :model.sync="filter.pickingByUserName" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-combobox-autocomplete :options="pickingStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Picking Status" id="filter-" size="sm" :model.sync="filter.pickingStatusId" @input="getPickingStatuss" @focus="getPickingStatuss" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPickingForDeliverys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Picking For Delivery</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm" v-if="isShowDefaultFeature">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false) && isShowDefaultFeature" href="files/pickingfordelivery/PickingForDelivery.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false) && isShowDefaultFeature" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)  && isShowDefaultFeature" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start Scan</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData" v-if="isShowDefaultFeature"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton && isShowDefaultFeature"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm" ><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-pickingfordelivery" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="pickingForDeliverys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="pickingForDeliverys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Picking No" class="table-filter">
							<b-form-input id="input-picking-number-table" @input="getPickingForDeliverysWithoutLoading" v-model="filter.pickingNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Delivery Instruction" class="table-filter">
							<v-select append-to-body label="diNumber" :options="deliveryInstructions" :value="filter.deliveryInstructionId" :reduce="item => item.id" v-model="filter.deliveryInstructionId" :filterable="true" @input="getPickingForDeliverysWithoutLoading" @search="getDeliveryInstructions"></v-select>
						</b-th>
						<b-th stacked-heading="Picking Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder="" id="input-picking-date-from-table" reset-button @input="getPickingForDeliverysWithoutLoading" v-model="filter.pickingDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder="" id="input-picking-date-to-table" reset-button @input="getPickingForDeliverysWithoutLoading" v-model="filter.pickingDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Start Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getPickingForDeliverysWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Finish Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-finish-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Finish Date" size="sm" :modelFrom.sync="filter.finishDateFrom" :modelTo.sync="filter.finishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getPickingForDeliverysWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Customer" class="table-filter">
							<v-select append-to-body label="name" :options="customers" :value="filter.customerId" :reduce="item => item.id" v-model="filter.customerId" :filterable="true" @input="getPickingForDeliverysWithoutLoading" @search="getCustomers"></v-select>
						</b-th>
						<b-th stacked-heading="Picking By" class="table-filter">
							<v-select append-to-body label="firstName" :options="userInfos" :value="filter.pickingByUserName" :reduce="item => item.userName" v-model="filter.pickingByUserName" :filterable="true" @input="getPickingForDeliverysWithoutLoading" @search="getUserInfos"></v-select>
						</b-th>
						<b-th stacked-heading="Picking Status" class="table-filter">
							<v-select append-to-body label="name" :options="pickingStatuss" :value="filter.pickingStatusId" :reduce="item => item.id" v-model="filter.pickingStatusId" :filterable="true" @input="getPickingForDeliverysWithoutLoading" @search="getPickingStatuss"></v-select>
						</b-th>

						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false) && isShowDefaultFeature" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(pickingnumber)="row">
						
					{{ row.item.pickingNumber }}
						<!-- <a @click="() => ( $router.push({ name: 'pickingfordeliverydetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.pickingNumber != null && row.item.pickingNumber != "" ?
								(typeof row.item.pickingNumber == 'string') ?
									row.item.pickingNumber.slice(0, 30) + (row.item.pickingNumber.length > 30 ? "..." : "" ) : row.item.pickingNumber : "" }}
						</a> -->
					</template>

			<template v-slot:cell(deliveryInstruction)="row">

				<a @click="showDetail(row.item)" class="a-link-detail">
					{{ row.item.deliveryInstruction != null &&  row.item.deliveryInstruction.diNumber != null && row.item.deliveryInstruction.diNumber != "" ?
								(typeof row.item.deliveryInstruction.diNumber == 'string') ?
									row.item.deliveryInstruction.diNumber.slice(0, 30) + (row.item.deliveryInstruction.diNumber.length > 30 ? "..." : "" ) : row.item.deliveryInstruction.diNumber : "" }}

					<!-- {{ row.item.deliveryInstruction != null ? row.item.deliveryInstruction.diNumber : "" }} -->
				</a>
			</template>
			<template v-slot:cell(deliveryDate)="row">
				{{ row.item.deliveryInstruction != null ? row.item.deliveryInstruction.diDeliveryDate : null | moment("DD MMMM YYYY") }}
			</template>
			<template v-slot:cell(startDate)="row">
				{{ row.item.startDate | moment("DD MMMM YYYY HH:mm") }}
			</template>
			<template v-slot:cell(finishDate)="row">
				{{ row.item.finishDate | moment("DD MMMM YYYY HH:mm") }}
			</template>
			<template v-slot:cell(diCustomer)="row">
				{{ row.item.deliveryInstruction != null ? ((row.item.deliveryInstruction.diCustomer != null) ? row.item.deliveryInstruction.diCustomer.name : null) : null }}
			</template>
			<template v-slot:cell(pickingBy)="row">
				{{ row.item.pickingBy != null ? row.item.pickingBy.firstName : "" }}
			</template>
			<template v-slot:cell(pickingStatus)="row">
				<div class="two-item">
					<span>{{ row.item.pickingStatus != null ? row.item.pickingStatus.code : "" }}</span>
					<span :class="getRectangleClass(row.item.pickingStatus.code)">&nbsp;</span>
				</div>
			</template>


					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2"  v-if="isShowDefaultFeature" >
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span  v-if="false">
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-picking-di-customer" label-cols-lg="12" label="Customer" size="sm" :model="row.item.deliveryInstruction != null ? ((row.item.deliveryInstruction.diCustomer != null) ? row.item.deliveryInstruction.diCustomer.name :null) : null" :isUpdatable="false" :isEditable="false"  />
						<app-input-datepicker  id="fieldset-picking-date" label-cols-lg="12"  label="Picking Date" size="sm" :model.sync="row.item.pickingDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="row.item.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-finish-date" label-cols-lg="12"  label="Finish Date" size="sm" :model.sync="row.item.finishDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="12" :model="row.item.pickingByUserName" label="Picking By" :selected="row.item.pickingBy != null ? row.item.pickingBy.firstName : ''" :isEditable="false" :isUpdatable="true" @input="getUserInfos" @focus="getUserInfos"/>
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.pickingStatusId" label="Picking Status" :selected="row.item.pickingStatus != null ? row.item.pickingStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						<!-- <app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Picking By" id="filter-" size="sm" :model.sync="filter.pickingByUserName" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-combobox-autocomplete :options="pickingStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Picking Status" id="filter-" size="sm" :model.sync="filter.pickingStatusId" @input="getPickingStatuss" @focus="getPickingStatuss" /> -->

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(pickingForDeliverysPaging != null ? pickingForDeliverysPaging.dataCount : 0)"
									:per-page="(pickingForDeliverysPaging != null ? pickingForDeliverysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-pickingfordelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-pickingfordelivery.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-pickingfordelivery.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		width: 30px;
		height: 30px;
	}
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import PickingForDeliveryList from '@/models/PickingForDelivery/PickingForDeliveryList';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';
import RoleDetail from '@/models/Core/RoleDetail';
// import moment from 'moment';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PickingStatusFilter from '@/filters/PickingStatus/PickingStatusFilter';
import PickingStatus from '@/models/PickingStatus/PickingStatus';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
export default {
	components : {
		PickingForDelivery, 
		PickingForDeliveryList, 
		PickingForDeliveryFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputTextbox
	},
	data() {
		return {
			selectAll:false,
			sortBy: 'createddate',
			sortDesc: false,
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"pickingNumber": {}, "class" : "th-picking-number d-stack-none", "label" : "Picking No", key: 'pickingNumber', sortable: false}, 
				{"deliveryInstruction": {}, "class" : "th-delivery-instruction first-child", "label" : "Delivery Instruction", key: 'deliveryInstruction', sortable: false}, 
				{"deliveryDate": {}, "class" : "th-delivery-date", "label" : "Delivery Date", key: 'deliveryDate', sortable: false}, 
				//{"pickingDate": {}, "class" : "th-picking-date last-child", "label" : "Picking Date", key: 'pickingDate', sortable: false}, 
				{"startDate": {}, "class" : "th-start-date d-stack-none", "label" : "Start Date", key: 'startDate', sortable: false}, 
				{"finishDate": {}, "class" : "th-finish-date d-stack-none", "label" : "Finish Date", key: 'finishDate', sortable: false}, 
				{"diCustomer": {}, "class" : "th-picking-di-customer second-child", "label" : "Customer", key: 'diCustomer', sortable: false}, 
				{"pickingBy": {}, "class" : "th-picking-by d-stack-none", "label" : "Picking By", key: 'pickingBy', sortable: false}, 
				{"pickingStatus": {}, "class" : "th-picking-status", "label" : "Picking Status", key: 'pickingStatus', sortable: false}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			isShowDefaultFeature:false,
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			pickingForDeliverys: [],
			pickingForDeliverysPaging: {},
			deliveryInstructions : [],
			userInfos : [],
			pickingStatuss : [],
			pickingForDeliveryDetails : [],
			pickingCardDetails : [],
			customers: [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
		}
	},	methods : {
		showDetail(item){
			this.$router.push({ name: this.getTargetView(item), params : { id: item.id } });
		},
		getTargetView(item){
			var targetView = item.pickingStatus!=null && (item.pickingStatus.code.toUpperCase() == "OPEN" || item.pickingStatus.code.toUpperCase() == "IN_PROGRESS") ? 'PickingForDeliveryScan' : 'PickingForDeliveryDetail';
			// console.log(targetView.toLowerCase());
			return targetView.toLowerCase();
		},
		getRectangleClass(documentStatus) {
			documentStatus = documentStatus.toUpperCase();
			let cls = "rectangle";
			if(documentStatus == "DONE") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			return cls;
		}, 
		getPickingForDeliverys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PickingForDelivery.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingForDeliverys = result.data
					this.pickingForDeliverysPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPickingForDeliverysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PickingForDelivery.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.pickingForDeliverys = result.data
					this.pickingForDeliverysPaging = result
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}

			if(this.filter.deliveryInstructionId != undefined && input == '') {
				filter.id = this.filter.deliveryInstructionId;
			}

			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.name = input;
			}

			if(this.filter.customerId != undefined && input == '') {
				filter.id = this.filter.customerId;
			}

			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getPickingStatuss : async function(input) {
			let filter = new PickingStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PickingStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new PickingForDeliveryFilter();
			this.getPickingForDeliverys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPickingForDeliverys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PickingForDelivery.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PickingForDelivery.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			// console.log('this.filter', this.filter);
			PickingForDelivery.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				// console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			let createRoute = 'pickingfordeliveryedit';
			if(this.isScannerMode) {
				createRoute = 'pickingfordeliveryscan';
			}
			// this.$router.push({ name: createRoute});
			this.isCreateBusy = true;
			PickingForDelivery.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'pickingfordeliveryedit';
						if(this.isScannerMode) {
							createRoute = 'pickingfordeliveryscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PickingForDelivery.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'pickingfordeliveryedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PickingForDelivery.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPickingForDeliverys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PickingForDelivery.deleteMultipleData(this).then(result => {
					this.getPickingForDeliverys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePickingForDeliveryParent = document.getElementById('table-list-pickingfordelivery').parentNode;
			tablePickingForDeliveryParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePickingForDeliveryParent.scrollWidth - tablePickingForDeliveryParent.offsetWidth) == Math.ceil(tablePickingForDeliveryParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePickingForDeliveryParent = document.getElementById('table-list-pickingfordelivery').parentNode;
			tablePickingForDeliveryParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePickingForDeliveryParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PickingForDeliveryFilter();
		this.getDeliveryInstructions()
		this.getUserInfos()
		this.getPickingStatuss()
		this.getCustomers()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Picking For Delivery"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPickingForDeliverys();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPickingForDeliverys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPickingForDeliverys();
			}
		},
		currentPage: {
			handler: function() {
				this.getPickingForDeliverys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPickingForDeliverys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PickingForDelivery.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "pickingfordeliveryindex") {
					this.getPickingForDeliverysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "picking_for_delivery").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
